module.exports = __webpack_public_path__ + "img/competencies_quality_swiper_03.6af550ea.jpg";